// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1uVkN","footer":"ModalInfo_footer__DWjFz"};